<app-filters-dropdown-item
    title="{{ 'shared.projectScopeSelection.myCommunities' | translate }}"
    collapseId="communitiesCollapse"
    checkAllLabel="{{ 'filters.shared.allCommunitiesFilters' | translate }}"
    [isCommunity]="true"
    [options]="userCommunitiesFilterItems"
    [checkAllEnabled]="true"
    [projectsDirectory]="projectsDirectory"
    (selectionChange)="onCommunitiesSelectionChanged()"
    (checkAllSelectionChange)="onAllMyCommunitiesSelectionChanged($event)"
>
</app-filters-dropdown-item>
